export default class SimpleInterpolator {
  private readonly pattern: RegExp;

  constructor(prefix = '{{', suffix = '}}') {
    this.pattern = new RegExp(
      this.escapeRegex(prefix) + '\\s*(\\w+)\\s*' + this.escapeRegex(suffix),
      'g'
    );
  }

  private escapeRegex(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  public replace(
    input: string,
    replacements: Record<string, string | number | null | undefined>
  ): string {
    return input.replace(this.pattern, (_, key: string) => {
      const replacementValue = replacements[key] ?? '';
      return typeof replacementValue === 'string' ? replacementValue : String(replacementValue);
    });
  }
}
